import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { DEFAULT_LOGIN_LABELS, GET_STATIC_CONTENT, SITE_LEISURE } from '@whitbread-eos/api';
import { useCustomLocale, useQueryRequest } from '@whitbread-eos/utils';
import { useEffect, useState } from 'react';
import AuthContentManagerPIVariant from './AuthContentManagerPIVariant.component';
import { jsx as _jsx } from "react/jsx-runtime";
export default function AuthContentManagerPIVariantContainer(_ref) {
  var _data$headerInformati3;
  var isLoginModalOpen = _ref.isLoginModalOpen,
    toggleLoginModal = _ref.toggleLoginModal;
  var _useCustomLocale = useCustomLocale(),
    currentLanguage = _useCustomLocale.language,
    currentCountry = _useCustomLocale.country;
  var _useQueryRequest = useQueryRequest(['GetStaticContent', currentLanguage, currentCountry], GET_STATIC_CONTENT, {
      language: currentLanguage,
      country: currentCountry,
      site: SITE_LEISURE,
      businessBooker: false
    }),
    data = _useQueryRequest.data;
  var _useState = useState(DEFAULT_LOGIN_LABELS),
    _useState2 = _slicedToArray(_useState, 2),
    labels = _useState2[0],
    setLabels = _useState2[1];
  useEffect(() => {
    var _data$headerInformati;
    if (data !== null && data !== void 0 && (_data$headerInformati = data.headerInformation) !== null && _data$headerInformati !== void 0 && (_data$headerInformati = _data$headerInformati.content) !== null && _data$headerInformati !== void 0 && _data$headerInformati.authentication) {
      var _data$headerInformati2;
      setLabels(data === null || data === void 0 || (_data$headerInformati2 = data.headerInformation.content) === null || _data$headerInformati2 === void 0 ? void 0 : _data$headerInformati2.authentication);
    }
  }, [data === null || data === void 0 || (_data$headerInformati3 = data.headerInformation) === null || _data$headerInformati3 === void 0 || (_data$headerInformati3 = _data$headerInformati3.content) === null || _data$headerInformati3 === void 0 ? void 0 : _data$headerInformati3.authentication]);
  return _jsx(AuthContentManagerPIVariant, {
    isLoginModalOpen: isLoginModalOpen,
    toggleLoginModal: toggleLoginModal,
    labels: labels,
    headerInfoData: data === null || data === void 0 ? void 0 : data.headerInformation
  });
}